import { useGetCurrentUserQuery } from '../../../store/user/userApi';

const LogoHomepage = () => {
	const { data: userInfo, isLoading } = useGetCurrentUserQuery();

	return (
		<div className='max-w-full xl:w-[760px] relative mx-auto my-10'>
			{!isLoading && <div className="relative w-full h-96 rounded-2xl overflow-hidden z-0 flex">
					<img src="/images/orient-express.webp" alt="orient-express" className="absolute w-full h-full object-cover top-0 left-0 p-0 -z-10" />
				<div className="absolute w-full h-full object-cover top-0 left-0 p-0 -z-10 bg-white dark:bg-black dark:bg-opacity-40 bg-opacity-40" />
				<img src={userInfo?.data.logoUrl || '/images/logo.svg'} className={'m-auto w-80'} alt={userInfo?.data.name} />
            </div>}
		</div>
	)
}

export default LogoHomepage;